import styled from 'styled-components';

export const Container = styled.div`
width:100%;
display: flex;
justify-content: center;
align-items: center;

padding: 30px;

`;




